import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';
import type { ProfilePictureMacroRendererProps } from '../src/profile-picture/ProfilePictureMacroRenderer.tsx';

export const ProfilePictureMacroHandler: LoadableType<ProfilePictureMacroRendererProps> =
	LoadableAfterPaint({
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-ProfilePictureMacro" */ '../src/profile-picture/ProfilePictureMacroRenderer.tsx'
				)
			).ProfilePictureMacroRenderer,
	});
